<template>
  <div>
    <mdb-modal size="lg" @shown="componentDidMount" :show="visible" @close="hideModal">
      <mdb-modal-header>
        <mdb-modal-title>Transaction Detail: <strong>{{transaction?transaction.ref_number:''}}</strong></mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body v-if="transaction">
          <mdb-row class="mb-3">
              <mdb-col col="6">
                  <mdb-input disabled class="m-1" outline label="Service Type" v-model="transaction.service_type" /> 
              </mdb-col>
              <mdb-col col="6">
                  <mdb-input disabled class="m-1" outline label="Amount (RM)" v-model="transaction.amount" /> 
              </mdb-col>
          </mdb-row>
           <mdb-row class="mb-3">
              <mdb-col col="6">
                  <mdb-input disabled class="m-1" outline label="Full Name" v-model="transaction.partner_profile.fullname" /> 
              </mdb-col>
              <mdb-col col="6">
                  <mdb-input disabled class="m-1" outline label="Remark" v-model="transaction.remark" /> 
              </mdb-col>
          </mdb-row>
          <mdb-row>
            <mdb-col col="12">
              <mdb-input disabled class="m-1" outline label="Additional Remark" v-model="transaction.remark2" /> 
            </mdb-col>
          </mdb-row>
          <mdb-row>
              <mdb-col v-for="(image, index) in attachments" v-bind:key="image" col="4" class="d-flex flex-column align-items-center">
                    <img @click="showLightBox(index)" class="waves-effect img-fluid" :src="renderAttachment(image)" />
                </mdb-col>
          </mdb-row>
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="loading" small color="blue"/>
      </mdb-modal-footer>
      <mdb-lightbox
        :visible="lightbox_modal"
        :imgs="lightbox_imgs"
        :index="lightbox_index"
        @hide="lightbox_modal=false"
        ></mdb-lightbox>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbSpinner, mdbRow, mdbCol, mdbLightbox, mdbInput } from 'mdbvue';
  import {APP_FILE_URL} from '../js/config';
  export default {
    components: {
      mdbModal, mdbRow, mdbCol,
      mdbModalHeader, mdbSpinner,
      mdbModalTitle,
      mdbModalBody, mdbInput,
      mdbModalFooter, mdbLightbox
    },
    props: ['visible', 'close', 'transaction'],
    data: ()=>({
      loading: false,
      attachments: [],
        lightbox_modal: false,
        lightbox_imgs:[],
        lightbox_index:0,
    }),
    methods: {
        componentDidMount(){
            this.attachments=JSON.parse(this.transaction.attachments);
        },
        hideModal(){
          this.attachments=[];
            this.lightbox_modal=false;
            this.close();
        },
        renderAttachment(image){
            return APP_FILE_URL+image;
        },
        showLightBox(index){
            var temp_images=[];
            this.attachments.forEach(element => {
                temp_images.push(APP_FILE_URL+element);
            });
            this.lightbox_modal=true,
            this.lightbox_imgs=temp_images,
            this.lightbox_index=index;
        }
    }
  };
</script>

<style scoped>
</style>